/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerSkipForward = createReactComponent(
  "player-skip-forward",
  "IconPlayerSkipForward",
  [
    ["path", { d: "M4 5v14l12 -7z", key: "svg-0" }],
    ["path", { d: "M20 5l0 14", key: "svg-1" }]
  ]
);

export { IconPlayerSkipForward as default };
//# sourceMappingURL=IconPlayerSkipForward.js.map
